// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import IdleVue from 'idle-vue'
import BootstrapVue from 'bootstrap-vue'
import VueSession from 'vue-session'
import VueCookies from 'vue-cookies'

import 'bootstrap/dist/css/bootstrap.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

import VueCarousel from 'vue-carousel'
import VCalendar from 'v-calendar'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'vue-search-select/dist/VueSearchSelect.css'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
// list used icon
import {
  faPaw,
  faHiking,
  faSkiingNordic,
  faSkiing,
  faSnowboarding,
  faStar,

  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faBell,
  faCalendarAlt,
  faCalendarCheck,
  faChartLine,
  faCheck,
  faClock,
  faCogs,
  faCreditCard,
  faCircle,
  faEnvelope,
  faFlag,
  faGlobe,
  faHeart,
  faHeartBroken,
  faHeadset,
  faHistory,
  faKey,
  faLuggageCart,
  faMapMarkerAlt,
  faMoneyBillWave,
  faMugHot,
  faPencilAlt,
  faPhone,
  faPlus,
  faRunning,
  faSearch,
  faShieldAlt,
  faSignOutAlt,
  faSmile,
  faStreetView,
  faTimes,
  faUndo,
  faUpload,
  faUserAlt,
  faUsers,
  faVenusMars
} from '@fortawesome/free-solid-svg-icons'
// END list used icon

let eventsHub = new Vue()

const idleOptions = {
  eventEmitter: eventsHub,
  idleTime: 30 * 60 * 1000, // minutes seconds
  startAtIdle: false
}

let sessionOptions = {
  persist: true
}

VueCookies.config('1d')
Vue.config.productionTip = false

Vue.use(IdleVue, idleOptions)
Vue.use(BootstrapVue)
Vue.use(VueSession, sessionOptions)
Vue.use(VueCookies)
Vue.use(require('vue-moment'))

Vue.use(VueCarousel)
Vue.use(VCalendar)
Vue.use(datePicker)

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

library.add(faPaw)
library.add(faHiking)
library.add(faSkiingNordic)
library.add(faSkiing)
library.add(faSnowboarding)
library.add(faStar)

library.add(faAngleUp)
library.add(faAngleDown)
library.add(faAngleLeft)
library.add(faAngleRight)
library.add(faArrowUp)
library.add(faArrowDown)
library.add(faArrowLeft)
library.add(faArrowRight)
library.add(faBell)
library.add(faCalendarAlt)
library.add(faCalendarCheck)
library.add(faChartLine)
library.add(faCheck)
library.add(faClock)
library.add(faCogs)
library.add(faCreditCard)
library.add(faCircle)
library.add(faEnvelope)
library.add(faFlag)
library.add(faGlobe)
library.add(faHeart)
library.add(faHeartBroken)
library.add(faHeadset)
library.add(faHistory)
library.add(faKey)
library.add(faLuggageCart)
library.add(faMapMarkerAlt)
library.add(faMoneyBillWave)
library.add(faMugHot)
library.add(faPencilAlt)
library.add(faPhone)
library.add(faPlus)
library.add(faRunning)
library.add(faSearch)
library.add(faShieldAlt)
library.add(faSignOutAlt)
library.add(faSmile)
library.add(faStreetView)
library.add(faTimes)
library.add(faUndo)
library.add(faUpload)
library.add(faUserAlt)
library.add(faUsers)
library.add(faVenusMars)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.mixin({
  data: function () {
    return {
      get globalProp () {
        return {
          vs: 'https://api.starguides.co/'
        }
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js